// Our Django version is 1.11.29 as I see in the requirements file [1]
// At that version, Django uses a list of 1K common passwords [2]
// After filtered passwords contain at least 8 characters, there are only 153 passwords as below
// [1]: https://gitlab.worldquant.com/wqbraintech/websim/-/blob/3552d36c049966810fcf538bbcd627b9d45e0002/appserver/requirements/python.txt#L21
// [2]: https://github.com/django/django/blob/1daae25bdcd735151de394a5578c22257e3e5dc7/django/contrib/auth/common-passwords.txt.gz

export const COMMON_PASSWORDS: Set<string> = new Set([
  'password',
  '12345678',
  'baseball',
  'football',
  'jennifer',
  'superman',
  'trustno1',
  'michelle',
  'sunshine',
  '123456789',
  'starwars',
  'computer',
  'corvette',
  'princess',
  'iloveyou',
  'maverick',
  'samantha',
  'steelers',
  'whatever',
  'hardcore',
  'internet',
  'mercedes',
  'bigdaddy',
  'midnight',
  '11111111',
  'marlboro',
  'victoria',
  'butthead',
  'startrek',
  'liverpoo',
  'danielle',
  'redskins',
  'mountain',
  'shithead',
  'xxxxxxxx',
  '88888888',
  'nicholas',
  'metallic',
  'qwertyui',
  'dolphins',
  'cocacola',
  'rush2112',
  'jonathan',
  'scorpion',
  'asdfasdf',
  'godzilla',
  'williams',
  'lifehack',
  'platinum',
  'garfield',
  '69696969',
  'jordan23',
  'bullshit',
  'airborne',
  'elephant',
  'explorer',
  'christin',
  'december',
  'benjamin',
  'dickhead',
  'brooklyn',
  'redwings',
  'michigan',
  '87654321',
  'guinness',
  'einstein',
  'snowball',
  'alexande',
  'passw0rd',
  'lasvegas',
  'slipknot',
  'kimberly',
  '1q2w3e4r',
  'carolina',
  'colorado',
  'creative',
  'bollocks',
  'darkness',
  'asdfghjk',
  'poohbear',
  'nintendo',
  'november',
  'password1',
  'lacrosse',
  'paradise',
  'maryjane',
  'spitfire',
  'anderson',
  'cherokee',
  'drowssap',
  'marshall',
  '1qaz2wsx',
  'caroline',
  'franklin',
  'snickers',
  'courtney',
  'westside',
  'patricia',
  'semperfi',
  'freeuser',
  'babygirl',
  'champion',
  'softball',
  'security',
  'wildcats',
  'veronica',
  'abcd1234',
  'wolverin',
  'remember',
  'freepass',
  'pearljam',
  'mistress',
  'peekaboo',
  'budlight',
  'electric',
  'stargate',
  'brittany',
  'swimming',
  'scotland',
  'swordfis',
  'blink182',
  'virginia',
  'passport',
  'aaaaaaaa',
  'rolltide',
  'bulldogs',
  'liverpool',
  'chevelle',
  'mitchell',
  'spiderma',
  'patriots',
  'cardinal',
  'kawasaki',
  'ncc1701d',
  'airplane',
  'scarface',
  'elizabet',
  'wolfpack',
  'lawrence',
  'american',
  'stingray',
  'simpsons',
  'srinivas',
  'panthers',
  'pussycat',
  'loverboy',
  'tarheels',
  'wolfgang',
  'testtest',
  'michael1',
  'pakistan',
  'infinity',
  'letmein1',
]);
